import pl from './messages/pl.json'
import en from './messages/en.json'

export const list = [ 'pl', 'en' ]

export default {
    pl, en
}
